import { render, staticRenderFns } from "./subMemberPc.vue?vue&type=template&id=2088355e&scoped=true&"
import script from "./subMemberPc.vue?vue&type=script&lang=js&"
export * from "./subMemberPc.vue?vue&type=script&lang=js&"
import style0 from "./subMemberPc.vue?vue&type=style&index=0&id=2088355e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088355e",
  null
  
)

export default component.exports